import axios from 'axios'

const qs = require('qs')

const state = {
  adminInfo: {},
}

const actions = {
  fetchAdminShortInfo ({ commit, rootGetters, dispatch }, meta = {}) {
    meta.filialId = meta.filialId || rootGetters['branches/getLocalStorageBranch'].id
    meta.date = meta.date || rootGetters['orders/getSelectedDate']

    if (meta.clear) {
      commit('setAdminInfo', {})
    }

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchAdminShortInfo']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    // const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then((res) => {
        commit('setAdminInfo', res.data.data)
        return res
      })
      .catch((err) => err)
  },
  fetchBalance ({ rootGetters }, meta) {
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(`${rootGetters['api/fetchBalance']}${params}`)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
}

const mutations = {
  setAdminInfo (state, payload) {
    state.adminInfo = payload
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
